




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Request {
    advertiserLabel: string;
}

@Component({ components: { SimpleText } })
export default class Name extends Vue {
    @Prop( { default: null }) public request !: Request;

    public static getNeededFields(): string[] {
        return [
            "request.owner.fullName",
        ];
    }
}
